import { gql } from '@apollo/client';
import { renderFragments, resellerChipFragment } from '../../lib/fragments';

export const resellerChipDetailsQuery = gql`
  query resellerChipDetails($id: ID!) {
    resellerChip(id: $id) {
      ...resellerChip
    }

    currentUser {
      id
      email
      userHouseholds {
        householdRole
        household {
          pets {
            id
          }
        }
      }
      chipReseller {
        verified
        types
        contactInfo {
          primaryEmail
        }
      }
    }
  }

  ${renderFragments(resellerChipFragment)}
`;

export const registerThirdPartyChip = gql`
  mutation resellerRegisterThirdPartyChip($input: ThirdPartyChipInput!) {
    registerThirdPartyChip(input: $input) {
      id
      serialNumber
    }
  }
`;

export const recallChipMutation = gql`
  mutation resellerRecallChip($input: RecallChipInput!) {
    recallChip(input: $input) {
      id
    }
  }
`;

export const reassignChipToResellerMutation = gql`
  mutation reassignChipToReseller($input: ReassignChipToResellerInput!) {
    reassignChipToReseller(input: $input) {
      id
      serialNumber
      shortId
    }
  }
`;
